import type { FaireThemeEntity } from "../../entity_types/theme";

export const rustic_depot_game_night_gifts_board_games_puzzles: FaireThemeEntity =
  {
    token: "rustic-depot-game-night-gifts-board-games-puzzles",
    type: "theme",
    retailerToken: "r_464eox2tas",
    name: "Game Night Gifts",
    description: "Games and puzzles that fill a gifting niche",
    bgColor: "#D0E0E8",
    tileBgColor: "#4f8225",
    productTokens: [
      "p_b9ard9quv4",
      "p_293hb7qjnt",
      "p_r6u3ve4mdz",
      "p_yf8fghvuen",
    ],
    exactProducts: true,
    meta: {
      source: "mock",
      importedAt: "2026-03-24T13:50:10Z",
      importedBy: "retailer-themes-entity-migration",
    },
  };
